const routes = [
  {
    path: '',
    component: () => import('@/views/provider/trainingHistory/Wrapper.vue'),
    children: [
      {
        path: '/provider/trainingHistory',
        name: 'TrainingHistory',
        component: () =>
          import('@/views/provider/trainingHistory/TrainingHistory.vue'),
      },
      {
        path: '/provider/trainingDetail/:id',
        name: 'TrainingDetails',
        component: () =>
          import('@/views/provider/trainingHistory/TrainingDetails.vue'),
        props: true,
      },
    ],
  },
];

export default routes;
